import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import momiboLogo from '../assets/momibo03-momibo.png';

function HomePage() {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: 'chat',
      title: 'チャット',
      description: 'Momiboと会話する',
      icon: '💬',
      path: '/chat',
      color: '#abd4ff'
    },
    {
      id: 'upload',
      title: 'ドキュメント管理',
      description: 'ファイルや知識をアップロード',
      icon: '📁',
      path: '/upload',
      color: '#ffd2ab'
    },
    {
      id: 'history',
      title: '会話履歴',
      description: '過去の会話を確認',
      icon: '📜',
      path: '/history',
      color: '#d4abff'
    }
  ];

  return (
    <div className="home-page">
      <header className="home-header" style={{ backgroundImage: `url(${momiboLogo})` }}>
        <button
          className="home-btn"
          onClick={() => window.location.href = '/auth/dashboard'}
          style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            background: 'white',
            border: '2px solid #000064',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            fontSize: '28px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(0, 0, 100, 0.1)',
            zIndex: 1000,
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          🏠
        </button>
      </header>

      <div className="home-container">
        <div className="home-title-box">
          <div className="commissioner-title-text">Momibo</div>
          <p className="home-subtitle">あなたのAIアシスタント</p>
        </div>

        <div className="menu-grid">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="menu-card"
              onClick={() => navigate(item.path)}
              style={{ borderColor: item.color }}
            >
              <div className="menu-icon" style={{ backgroundColor: item.color }}>
                {item.icon}
              </div>
              <h3 className="menu-title">{item.title}</h3>
              <p className="menu-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
